var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgKubernetes2 = function SvgKubernetes2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 8.334v83.333m29.463-71.13L20.537 79.463M91.667 50H8.333m71.13 29.463L20.537 20.537M50 84.722c19.177 0 34.722-15.546 34.722-34.722 0-19.177-15.545-34.723-34.722-34.723-19.176 0-34.722 15.546-34.722 34.723 0 19.176 15.546 34.722 34.722 34.722Z",
    stroke: "#000",
    strokeWidth: 8.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgKubernetes2;